import axios from "./axiosInstance";

const ForgetEmailAPI = {
  postLoginDetails: (params) => axios.post(`/forgot_password`, params),
};

export default ForgetEmailAPI;
